import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';

@Directive({
  selector: 'input'
})
export class HackIosKeyboardOffsetDirective implements OnInit {
  @Input() matDatepicker;

  constructor(private element: ElementRef, private platform: Platform) {}

  ngOnInit() {
    // Ionic input-shims modifyng keyboard-offset only happens on ios. Dont know why.
    if (!this.platform.is('ios')) {
      return;
    }
    this.element.nativeElement.addEventListener('focusin', e => {
      e.stopPropagation();
    });
  }
}
